import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import DashboardIcon from '@material-ui/icons/Dashboard'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import RepeatIcon from '@material-ui/icons/Repeat'
import AllInboxIcon from '@material-ui/icons/AllInbox'
import FilterListIcon from '@material-ui/icons/FilterList'
import Dashboard from './ActiveNowMobile/Dashboard'
import Trucks from './ActiveNowMobile/Trucks'
import Projects from './ActiveNowMobile/Projects'
import Hauls from './ActiveNowMobile/Hauls'
import Filters from './ActiveNowMobile/Filters'
import { filterActiveNow } from './ActiveNowMobile/helper'
import { useDispatch } from 'react-redux'
import { getActiveNow } from '../ActiveNow/Store/actions'

const ActiveNowMobile = props => {
  const dispatch = useDispatch()
  const [currentTab, setCurrentTab] = useState(0)
  const numFiltersApplied =
    props.activeNow.filters.hauls.length + props.activeNow.filters.projects.length

  const foremanHaul =
    props.userData.isForeman && !props.hauls.isLoading && props.hauls.length > 0
      ? props.hauls.find(haul => {
          return (
            (haul.siteContact && haul.siteContact.phoneNumber === props.userData.phone) ||
            (haul.superIntendant && haul.superIntendant.phoneNumber === props.userData.phone)
          )
        })
      : undefined

  const handleChangeTab = tabNumber => {
    setCurrentTab(tabNumber)
    switch (tabNumber) {
      case 0:
        props.history.push(`/app/active/dashboard`)
        break
      case 1:
        props.history.push(`/app/active/trucks`)
        break
      case 2:
        props.history.push(`/app/active/hauls`)
        break
      case 3:
        props.history.push(`/app/active/projects`)
        break
      case 4:
        props.history.push(`/app/active/filter`)
        break
      default:
        break
    }
  }

  const ScreenTab = () => {
    switch (currentTab) {
      case 0:
        return <Dashboard {...props} handleChangeTab={handleChangeTab} />
      case 1:
        return <Trucks {...props} foremanHaul={foremanHaul} isForeman={props.userData.isForeman} />
      case 2:
        return <Hauls {...props} />
      case 3:
        return <Projects {...props} />
      case 4:
        return <Filters {...props} />
      default:
        break
    }
  }

  // useEffect(() => {
  //   dispatch(getActiveNow())
  // }, [currentTab])

  useEffect(() => {
    switch (props.location.pathname) {
      case '/app/active':
        setCurrentTab(0)
        break
      case '/app/active/dashboard':
        setCurrentTab(0)
        break
      case '/app/active/trucks':
        setCurrentTab(1)
        break
      case '/app/active/hauls':
        setCurrentTab(2)
        break
      case '/app/active/projects':
        setCurrentTab(3)
        break
      case '/app/active/filter':
        setCurrentTab(4)
        break
      default:
        break
    }
  }, [props, props.match.params, props.location.pathname])

  return !props.activeNow.loading ? (
    <div>
      <div style={{ width: '100%', display: 'flex' }}>
        {[
          <DashboardIcon style={{ width: '24px', padding: '5px' }} />,
          <LocalShippingIcon style={{ width: '24px', padding: '5px' }} />,
          <RepeatIcon style={{ width: '24px', padding: '5px' }} />,
          <AllInboxIcon style={{ width: '24px', padding: '5px' }} />,
          <FilterListIcon style={{ width: '24px', padding: '5px' }} />
        ].map((item, i) => (
          <div
            key={i}
            style={{
              minWidth: '56px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '40px',
              backgroundColor: currentTab === i ? '#B8D5FC' : '#F6F9FD',
              position: 'relative'
            }}
            onClick={() => handleChangeTab(i)}
          >
            {item}
            {i === 4 && numFiltersApplied ? (
              <div
                style={{
                  position: 'absolute',
                  top: '3px',
                  right: '8px',
                  width: '20px',
                  height: '14px',
                  background: '#3587F5',
                  border: '1px solid #EAEDF3',
                  borderRadius: '3px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: '#FFF',
                  fontSize: '12px'
                }}
              >
                {numFiltersApplied}
              </div>
            ) : null}
          </div>
        ))}
      </div>

      {ScreenTab()}
    </div>
  ) : (
    <></>
  )
}
const mapStateToProps = state => {
  return {
    activeNow: filterActiveNow(state) || state.activeNow,
    userData: state.user.userData,
    hauls: state.hauls.haulList
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ActiveNowMobile)
